import { useState, useEffect } from 'react';
import api from '../services/api';

interface OperationalStats {
  capacity_utilization: number;
  avg_punctuality: number;
  avg_waiting_time: number;
  patient_satisfaction: number;
  daily_efficiency: Array<{
    date: string;
    appointments_scheduled: number;
    appointments_completed: number;
    avg_appointment_duration: number;
    revenue_per_hour: number;
  }>;
  doctor_performance: Array<{
    doctor_name: string;
    punctuality_rate: number;
    satisfaction_score: number;
    daily_revenue: number;
    daily_treatments: number;
  }>;
  inventory_status: Array<{
    item_category: string;
    current_stock: number;
    minimum_required: number;
  }>;
  equipment_maintenance: Array<{
    equipment_name: string;
    last_maintenance: string;
    status: 'optimal' | 'maintenance_due' | 'critical';
  }>;
  patient_flow_hourly: Array<{
    hour: string;
    arrivals: number;
    in_treatment: number;
    waiting: number;
  }>;
  peak_hours: string[];
  low_stock_items: number;
}

export function useOperationalStats(dateRange: { start_date?: string; end_date?: string }) {
  const [data, setData] = useState<OperationalStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await api.get('/dashboard/operational-stats/', {
          params: dateRange
        });
        setData(response.data);
        setError(null);
      } catch (err) {
        setError('Erreur lors du chargement des statistiques opérationnelles');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dateRange.start_date, dateRange.end_date]);

  return { data, isLoading, error };
}